import * as React from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toast host. Theme-agnostic (no next-themes dependency); colors are driven by
 * the design tokens so toasts match the rest of the app.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="system"
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
